import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from 'reactstrap';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { InputDate } from '@components/form';

const ProrrogarTesteModal = ({ isOpen, toggle, contaId, nomeConta, dataAtual, onSubmit }) => {
  const validationSchema = Yup.object().shape({
    dataFimPeriodoTeste: Yup.date()
      .typeError('Data inválida')
      .required('Este campo é obrigatório')
      .min(new Date(), 'A data deve ser posterior à data atual'),
  });

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Prorrogar Período de Teste</ModalHeader>
      <Formik
        initialValues={{
          dataFimPeriodoTeste: '',
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          onSubmit({
            id: contaId,
            dataFimPeriodoTeste: values.dataFimPeriodoTeste
          });
          toggle();
        }}
      >
        {({ errors, touched, handleSubmit }) => (
          <Form>
            <ModalBody>
              <p>Você está prestes a prorrogar o período de teste para a conta: <strong>{nomeConta}</strong></p>
              <p>Data atual de expiração: {dataAtual}</p>
              
              <InputDate
                name="dataFimPeriodoTeste"
                label="Nova data de término do teste"
                col={12}
              />
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={toggle}>Cancelar</Button>
              <Button color="primary" onClick={handleSubmit}>Confirmar</Button>
            </ModalFooter>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default ProrrogarTesteModal;
